import { t } from "ttag";

import type { SpecialGroupType } from "metabase/admin/permissions/types";
import { PLUGIN_TENANTS } from "metabase/plugins";
import type { GroupInfo } from "metabase-types/api";

const SPECIAL_GROUP_NAMES = new Map([
  // eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
  ["All Users", t`All Users`],
  // eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
  ["Administrators", t`Administrators`],
  // eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
  ["All tenant users", t`All tenant users`],
  // eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
  ["Data Analysts", t`Data Analysts`],
]);

export function isDefaultGroup(group: Pick<GroupInfo, "magic_group_type">) {
  return group.magic_group_type === "all-internal-users";
}

export function isAdminGroup(group: Pick<GroupInfo, "magic_group_type">) {
  return group.magic_group_type === "admin";
}

export function isDataAnalystGroup(group: Pick<GroupInfo, "magic_group_type">) {
  return group.magic_group_type === "data-analyst";
}

export function getSpecialGroupType(
  group: Pick<GroupInfo, "magic_group_type">,
  isExternal: boolean = false,
): SpecialGroupType {
  if (isAdminGroup(group)) {
    return "admin";
  }
  if (isDataAnalystGroup(group)) {
    return "analyst";
  }
  if (isExternal) {
    return "external";
  }
  return null;
}

export function canEditPermissions(group: Pick<GroupInfo, "magic_group_type">) {
  return !isAdminGroup(group);
}

export function canEditMembership(group: Pick<GroupInfo, "magic_group_type">) {
  return !isDefaultGroup(group) && !PLUGIN_TENANTS.isExternalUsersGroup(group);
}

export function getGroupNameLocalized(group: Pick<GroupInfo, "name">) {
  return SPECIAL_GROUP_NAMES.get(group.name) ?? group.name;
}

export function getGroupSortOrder(group: Pick<GroupInfo, "magic_group_type">) {
  if (isAdminGroup(group)) {
    return 0;
  }
  if (isDefaultGroup(group)) {
    return 1;
  }
  if (isDataAnalystGroup(group)) {
    return 2;
  }
  return 3;
}
